import type { IconSvgObject } from './types';

const WalletNotFound01Icon: IconSvgObject = [
  ["path", { d: "M2 2L22 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 3H16C17.1046 3 18 3.89543 18 5V7H11M3.58579 3.58579C3.22386 3.94772 3 4.44772 3 5C3 6.10457 3.89543 7 5 7H7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 5V19C3 20.1046 3.89543 21 5 21H19C19.5523 21 20.0523 20.7761 20.4142 20.4142M21 17V9C21 7.89543 20.1046 7 19 7H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21 12H18C17.4477 12 17 12.4477 17 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default WalletNotFound01Icon;
